import config from '../../config';
import { getJwtToken } from '../../utilities/authentication';
import { getLanguageHeaders } from '../../store/services/http-common';
import { dedupeRequest } from '../requestDeduper';
import { queryKeys } from '../queryKeys';
import { queryClient } from '../queryClient';

export async function fetchVendorSettings() {
  const token = getJwtToken();
  if (!token) {
    throw new Error('Not authenticated');
  }

  return dedupeRequest(queryKeys.vendor.settings().join(':'), async () => {
    const response = await fetch(`${config.apiUrl}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        ...getLanguageHeaders(),
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw data ?? new Error('Failed to fetch vendor data');
    }

    return data;
  });
}

export function vendorQueryOptions() {
  return {
    queryKey: queryKeys.vendor.settings(),
    queryFn: fetchVendorSettings,
    staleTime: 5 * 60 * 1000,
    enabled: Boolean(getJwtToken()),
  };
}

export function invalidateVendorSettings() {
  return queryClient.invalidateQueries({ queryKey: queryKeys.vendor.settings() });
}
